import React, { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import './SessionWarningModal.css';

function SessionWarningModal() {
  const { sessionExpiryWarning, refreshSession, logout } = useAuth();
  const [autoLogoutCountdown, setAutoLogoutCountdown] = useState(60);
  const [refreshing, setRefreshing] = useState(false);

  // Auto-dismiss after 60 seconds of no interaction
  useEffect(() => {
    if (!sessionExpiryWarning) {
      setAutoLogoutCountdown(60);
      return;
    }

    const timer = setInterval(() => {
      setAutoLogoutCountdown(prev => {
        if (prev <= 1) {
          clearInterval(timer);
          handleNo();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [sessionExpiryWarning]);

  const handleYes = async () => {
    setRefreshing(true);
    try {
      await refreshSession();
    } catch (e) {
      // If refresh fails, force logout
      handleNo();
    }
    setRefreshing(false);
  };

  const handleNo = () => {
    logout();
    window.location.href = '/auth/session-expired';
  };

  if (!sessionExpiryWarning) return null;

  return (
    <div className="session-warning-overlay">
      <div className="session-warning-modal">
        <h3>Session is about to expire.</h3>
        <p>Do you want to stay signed in?</p>

        <div className="session-warning-actions">
          <button
            className="btn btn-primary session-warning-yes"
            onClick={handleYes}
            disabled={refreshing}
          >
            {refreshing ? 'Refreshing...' : 'Yes, stay signed in'}
          </button>
          <button
            className="btn btn-secondary session-warning-no"
            onClick={handleNo}
          >
            No, log out
          </button>
        </div>

        <p className="session-warning-hint">
          If No is selected, this tab will close. You will need to re-authenticate via the main website.
        </p>
        <p className="session-warning-countdown">
          Auto-logout in {autoLogoutCountdown}s
        </p>
      </div>
    </div>
  );
}

export default SessionWarningModal;
